
import { Button } from '@/components/ui/button';
import { Settings, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const PropertyOwnerSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          ¿Tienes una propiedad?
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          Puedes publicarla sin costo, o podemos ayudarte a administrarla
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="bg-brand-primary hover:bg-brand-primary-hover">
            <Link to="/gestiondepropiedad" className="flex items-center">
              <Settings className="w-5 h-5 mr-2" />
              Gestión de propiedades
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg">
            <Link to="/publicar" className="flex items-center">
              <Home className="w-5 h-5 mr-2" />
              Publicar mi propiedad
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PropertyOwnerSection;
